var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_vm._t("left"), _vm._v(" "), _c('div', {
    staticClass: "app-footer__social"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.facebook
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/social-facebook-icon.png",
      "alt": "Facebook"
    }
  })])]), _vm._v(" "), _vm._t("right")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55c48e4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/Footer.vue
// module id = Wb8P
// module chunks = 1